package oldframes.editors

import bootstrap.*
import ru.it_mozaika.utils.checkResponseError
import oldcomponents.*
import oldcomponents.page.PageContentProps
import oldcomponents.page.pageContent
import oldcomponents.rules.ruleGroup
import oldcomponents.templates.oldFreemarkerTemplate
import oldcomponents.triggers.triggerBlockComponent
import web.cssom.ClassName
import oldframes.files.uploadFileToServer
import io.ktor.client.call.*

import js.core.jso

import kotlinx.browser.window
import kotlinx.css.*
import kotlinx.html.InputType
import kotlinx.html.id
import kotlinx.html.js.*
import org.khronos.webgl.ArrayBuffer
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.events.MouseEvent
import org.w3c.files.FileReader
import org.w3c.files.get
import react.*
import react.dom.*

import react.router.dom.Link
import react.router.useNavigate
import react.router.useParams

import styled.*
import kotlin.Float
import react.dom.svg.ReactSVG.line
import react.dom.svg.ReactSVG.path
import ru.it_mozaika.sender.common.models.*
import ru.it_mozaika.sender.js.application.Http

val triggerEditorFrame = fc<PageContentProps> { props ->

    var isSidebarOpened by useState(true)

    val navigate = useNavigate()
    val id = useParams()["id"]
    useEffect(id) {
        if (id.isNullOrBlank()) { navigate("/triggers") }
    }

    kotlinext.js.require(".//assets/css/elisyam-1.5.min.css")
    kotlinext.js.require(".//assets/vendors/css/base/bootstrap.min.css")

    var trigger by useState<Trigger>()
    var steps by useState(mapOf<Int, TriggerStep>())
    var stepPositions by useState(mapOf<Int, TriggerStepPosition>())
    var stepConnectionLines by useState(listOf<dynamic>())
    var expandStates by useState(mapOf<Int, Boolean>())
    var stats by useState(mapOf<Int, TriggerStepStatistics>())
    var dragId by useState(-1)
    var deleteId by useState(-1)
    var editStep by useState<TriggerStep>()
    var editTemplate by useState<EmailTemplate>()
    var newStepId by useState(0)

    var showStats by useState(false)

    var width by useState(0.0f)
    var height by useState(0.0f)

    var hoverStep by useState(-1)
    var selectedConnector by useState<Pair<Int, Int>>()
    var selectedConnectorPosition by useState<Pair<Float, Float>>()
    var svgMousePosition by useState(0.0f to 0.0f)

    var stores by useState(mapOf<String,String>())
    var lists by useState(mapOf<String,Map<String, String>>())
    var senders by useState(mapOf<String, String>())
    var campaigns by useState(mapOf<String, String>())
    var staticSegments by useState(mapOf<String, String>())
    var dynamicSegments by useState(mapOf<String, String>())

    val events = mapOf(
        "AddSubscriber" to "Новый подписчик",
        "AbandonedBasket" to "Брошенная корзина",
        "BasketProductPriceDrop" to "Снизилась цена на товар в корзине",
        "ProductsReturnToStore" to "Товар снова в наличии",
        "Order" to "Заказ",
    )

    val actions = mapOf(
        "Subscribe" to "Подписать",
        "Unsubscribe" to "Отписать",
        "SendEmail" to "Отправить сообщение",
        "Separate" to "Разделить на две группы",
        "HttpRequest" to "HTTP запрос",
    )

    Modal {
        attrs.show = deleteId >= 0
        attrs.onHide = { deleteId = -1 }
        ModalHeader { ModalTitle { +"Удалить шаг ${deleteId + 1}?" } }
        ModalBody { +"Вы уверены что хотите удалить шаг ${deleteId + 1}? Данное действие невозможно отменить." }
        ModalFooter {
            Button {
                attrs.variant = "secondary"
                attrs.onClick = { deleteId = -1 }
                +"Отмена"
            }
            Button {
                attrs.variant = "gradient-01"
                attrs.onClick = {

                    steps = steps.minus(deleteId).mapValues { (_, value) ->
                        if (value.connections.flatten().contains(deleteId)) {
                            val connections = value.connections.map { it.minus(deleteId) }
                            value.copy(connections = connections)
                        } else {
                            value
                        }
                    }
                    deleteId = -1
                }
                +"Удалить"
            }
        }
    }


    var editedStepType by useState<TriggerStepType>()
    var isDelay by useState(false)
    var delayText by useState("")
    var randomText by useState("")

    var fileUploadProgress by useState(-1)
    val fileInputRef = useRef<HTMLInputElement>()
    styledForm {
        css.display = Display.none
        styledInput(InputType.file) {
            css.display = Display.none
            ref = fileInputRef
            attrs.onChangeFunction = {
                (it.target as? HTMLInputElement)?.let { input ->
                    input.files?.get(0)?.let { file ->
                        fileUploadProgress = 0
                        val reader = FileReader()
                        reader.readAsArrayBuffer(file)
                        reader.onload = { _ ->
                            val buffer = reader.result as ArrayBuffer
                            uploadFileToServer(trigger?.store.orEmpty(), file, buffer, { p -> fileUploadProgress = p }) { file ->
                                (editedStepType as? TriggerStepType.EmailTriggerStep)?.let { type ->
                                    editedStepType = type.copy(attachments = type.attachments.plus(file))
                                    fileUploadProgress = -1
                                }
                            }
                        }
                    }
                    input.value = ""
                }
            }
        }
    }
//    child(fileImportForm) {
//        attrs.refObject = fileInputRef
//        attrs.onUploadProgress = {
//            fileUploadProgress = it
//        }
//        attrs.onUploadStart = {
//            fileUploadProgress = 0
//        }
//        attrs.onUploadResult = {
//            (editedStepType as? TriggerStepType.EmailTriggerStep)?.let { type ->
//                editedStepType = type.copy(attachments = type.attachments.plus(it))
//            }
//        }
//    }

    useEffect(editStep) {
        editStep?.let {
            isDelay = it.delay >= 0L
            delayText = it.delay.toString()
            randomText = it.randomDelay.toString()
            editedStepType = it.type
            editTemplate = (it.type as? TriggerStepType.EmailTriggerStep)?.template
        }
    }

    Modal {
        attrs.show = editStep != null
        attrs.onHide = { editStep = null }
        attrs.size = "xl"
        ModalHeader { ModalTitle { +"Настройки шага ${editStep?.id}?" } }
        ModalBody {
            editStep?.let { step ->
                if (step.type !is TriggerStepType.StartTriggerStep && step.type !is TriggerStepType.TargetTriggerStep) {
                    div("form-group row d-flex align-items-center mb-5") {
                        label("col-3 form-control-label") { +"Выполнить с задержкой:" }
                        div("col-8 styled-checkbox ml-4") {
                            input(InputType.checkBox) {
                                attrs.id = "use-delay"
                                attrs.checked = isDelay
                                attrs.onChangeFunction = {
                                    delayText = if (isDelay) {
                                        randomText = "0"
                                        "-1"
                                    } else {
                                        "0"
                                    }
                                    isDelay = !isDelay
                                }
                                attrs.disabled = step.type is TriggerStepType.StartTriggerStep || step.type is TriggerStepType.TargetTriggerStep
                            }
                            label("text-primary") {
                                attrs["htmlFor"] = "use-delay"
                                +if (isDelay) "Да" else "Нет"
                            }
                        }
                    }

                    if (isDelay) {
                        div("form-group row d-flex align-items-center mb-5 pr-3") {
                            label("col-3 form-control-label") { +"Задержка выполнения (с.):" }
                            input(InputType.number, classes = "col-9 form-control") {
                                attrs.value = delayText
                                attrs.onChangeFunction = {
                                    delayText = (it.target as? HTMLInputElement)?.value.orEmpty()
                                }
                            }
                        }
                        div("form-group row d-flex align-items-center mb-5 pr-3") {
                            label("col-3 form-control-label") { +"Случайное время от 0 до (с.):" }
                            input(InputType.number, classes = "col-9 form-control") {
                                attrs.value = randomText
                                attrs.onChangeFunction = {
                                    randomText = (it.target as? HTMLInputElement)?.value.orEmpty()
                                }
                            }
                        }
                    }
                }

                when (val type = editedStepType) {
                    is TriggerStepType.StartTriggerStep -> {

                        val eventClsName = type.event::class.simpleName.orEmpty()
                        div("form-group row d-flex align-items-center mb-5 pr-3") {
                            label("col-3 form-control-label") { +"Событие:" }
                            div("col-9 p-0") {
                                child(dropdownSelect) {
                                    attrs {
                                        dropdownOpenDefault = false
                                        multiSelect = false
                                        showFilter = false
                                        currentValue = mapOf(eventClsName to events[eventClsName].orEmpty())
                                        selectValues = events.map { it.key to it.value }
                                        onSave = {
                                            editedStepType = type.copy(event = when(it.keys.first()) {
                                                "AddSubscriber" -> TriggerEvent.AddSubscriber()
                                                "AbandonedBasket" -> TriggerEvent.AbandonedBasket
                                                "BasketProductPriceDrop" -> TriggerEvent.BasketProductPriceDrop
                                                "ProductsReturnToStore" -> TriggerEvent.ProductsReturnToStore
                                                "Order" -> TriggerEvent.Order
                                                else -> TriggerEvent.AddSubscriber()
                                            })
                                        }
//                                            disabled = !edit
                                    }
                                }
                            }
                        }
                        when (val event = type.event) {
                            is TriggerEvent.AddSubscriber -> {
                                div("form-group row d-flex align-items-center mb-5 pr-3") {
                                    label("col-3 form-control-label") { +"Списки подписки:" }
                                    div("col-9 p-0") {
                                        child(dropdownSelect) {
                                            attrs {
                                                dropdownOpenDefault = false
                                                multiSelect = true
                                                showFilter = false
                                                currentValue = event.subscriptionListIds.associateWith { (lists[trigger?.store.orEmpty()] ?: mapOf())[it].orEmpty() }
                                                selectValues = (lists[trigger?.store.orEmpty()] ?: mapOf()).map { it.key to it.value }
                                                onSave = {
                                                    editedStepType = type.copy(event.copy(subscriptionListIds = it.keys.toList()))
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            TriggerEvent.AbandonedBasket -> {}
                            TriggerEvent.BasketProductPriceDrop -> {}
                            TriggerEvent.ProductsReturnToStore -> {}
                            TriggerEvent.Order -> {}
                        }
                    }
                    is TriggerStepType.TargetTriggerStep -> {
                        div("form-group row d-flex align-items-center mb-5 pr-3") {
                            label("col-3 form-control-label") { +"Наименование цели:" }
                            input(InputType.text, classes = "col-9 form-control") {
                                attrs.value = type.title
                                attrs.onChangeFunction = {
                                    editedStepType = type.copy(title = (it.target as? HTMLInputElement)?.value.orEmpty())
                                }
                            }
                        }
                        div("form-group row d-flex align-items-center mb-5") {
                            label("col-3 form-control-label") { +"Завершить выполнение триггера:" }
                            div("col-8 styled-checkbox ml-4") {
                                input(InputType.checkBox) {
                                    attrs.id = "final_${step.id}"
                                    attrs.checked = type.stopTrigger
                                    attrs.onChangeFunction = {
                                        editedStepType = type.copy(stopTrigger = !type.stopTrigger)
                                    }
                                }
                                label("text-primary") {
                                    attrs["htmlFor"] = "final_${step.id}"
                                    +if (type.stopTrigger) "Да" else "Нет"
                                }
                            }
                        }
                    }
                    is TriggerStepType.FilterTriggerStep -> {
                        ruleGroup {
                            attrs {
                                this.campaigns = campaigns
                                this.staticSegments = staticSegments
                                this.dynamicSegments = dynamicSegments
                                this.subscriptionLists = lists[trigger?.store.orEmpty()] ?: mapOf()
                                this.item = type.rules
                                this.onChange = {
                                    editedStepType = type.copy(rules = it)
                                }
                            }
                        }
                    }
                    is TriggerStepType.EmailTriggerStep -> {
                        div("form-group row d-flex align-items-center mb-5 pr-3") {
                            label("col-3 form-control-label") { +"Заголовок письма:" }
                            input(InputType.text, classes = "col-9 form-control") {
                                attrs.value = type.subject
                                attrs.onChangeFunction = {
                                    editedStepType = type.copy(subject = (it.target as? HTMLInputElement)?.value.orEmpty())
                                }
                            }
                        }
                        div("form-group row d-flex align-items-center mb-5 pr-3") {
                            label("col-3 form-control-label") { +"Отправитель:" }
                            div("col-9 p-0") {
                                child(dropdownSelect) {
                                    attrs {
                                        dropdownOpenDefault = false
                                        multiSelect = false
                                        showFilter = false
                                        currentValue = mapOf(type.sender to senders[type.sender].orEmpty())
                                        selectValues = senders.map { it.key to it.value }
                                        onSave = {
                                            editedStepType = type.copy(sender = it.keys.firstOrNull().orEmpty())
                                        }
//                                            disabled = !edit
                                    }
                                }
                            }
                        }

                        label("form-control-label") { +"Прикрепленные файлы (${type.attachments.size}):" }
                        type.attachments.forEach { file ->
                            div("form-group row d-flex align-items-center pl-3 pr-3") {
                                a("/files/${file.fileName}") {
                                    +file.originalName
                                }
                                iconButton {
                                    attrs.icon = "la la-trash"
                                    attrs.disabled = false
                                    attrs.type = IconButtonType.Danger
                                    attrs.onClickFunction = {
                                        editedStepType = type.copy(attachments = type.attachments.minus(file))
                                    }
                                }
                            }
                        }

                        div("form-group row d-flex align-items-center mb-5 pl-3 pr-3") {
                            Button {
                                attrs.type = web.html.ButtonType.button
                                attrs.variant = "primary"
                                attrs.className = ClassName("mr-3")
                                attrs.disabled = trigger?.id == null
                                i("la la-cloud-upload") {}
                                attrs.onClick = { e ->
                                    fileInputRef.current?.click()
                                }
                                +if (fileUploadProgress >= 0) {
                                    "Загрузка ${fileUploadProgress}%"
                                } else {
                                    "Добавить файл"
                                }
                            }
                        }

                        div("form-group row d-flex align-items-center mb-5 pl-3 pr-3") {
                            Button {
                                attrs.type = web.html.ButtonType.button
                                attrs.variant = "primary"
                                attrs.className = ClassName("mr-3")
                                attrs.disabled = trigger?.id == null
                                attrs.onClick = { e ->
                                    window.open("/editor/email?trigger=${trigger?.id}&step=${editStep?.id}")
//                                    fileInputRef.current?.click()
                                }
                                +"Редактировать шаблон"
                            }
                        }

                        div("form-group row d-flex align-items-center mb-5 pl-3 pr-3") {
                            Button {
                                attrs.type = web.html.ButtonType.button
                                attrs.variant = "primary"
                                attrs.className = ClassName("mr-3")
                                attrs.disabled = trigger?.id == null
                                attrs.onClick = { e ->
                                    editedStepType = type.copy(template = if (type.template is EmailTemplate.BlockEditor) EmailTemplate.Freemarker() else EmailTemplate.BlockEditor())
                                }
                                +"Преобразовать в ${if (type.template is EmailTemplate.BlockEditor) "HTML" else "блочную"} версию"
                            }
                        }

//                        div("form-group row d-flex align-items-center mb-5 pl-3 pr-3") {
//                            when (val template = editTemplate) {
//                                is EmailTemplate.Freemarker -> oldFreemarkerTemplate {
//                                    attrs.index = step.id
//                                    attrs.store = trigger?.store.orEmpty()
//                                    attrs.template = template
//                                    attrs.disabled = false
//                                    attrs.isActive = true
//                                    attrs.onChange = { idx, v ->
//                                        editTemplate = v
//                                    }
//                                }
//
//                                is EmailTemplate.BlockEditor -> {}//TODO
//                                null -> {}//TODO
//                            }
//                        }
                        div("form-group row d-flex align-items-center mb-5 pl-3 pr-3") {
                            Link {
                                attrs.to = "/triggers/${trigger?.id}/${editStep?.id}/preview"
                                Button {
                                    attrs.type = web.html.ButtonType.button
                                    attrs.variant = "primary"
                                    attrs.className = ClassName("mr-3")
                                    attrs.disabled = trigger?.id == null
                                    i("la la-eye") {}
                                    attrs.onClick = { e ->
                                        e.preventDefault()
                                        window.open("/triggers/${trigger?.id}/${editStep?.id}/preview", "_blank")
                                    }
                                    +"Предпросмотр"
                                }
                            }
//                            Button {
////                                    attrs.className = "ml-3"
//                                attrs.variant = "primary"
//                                attrs.onClick = {
//
//                                }
//                                +"Предпросмотр"
//                            }
                        }
                    }
                    is TriggerStepType.ConditionTriggerStep -> {
                        val eventClsName = type.event::class.simpleName.orEmpty()
                        div("form-group row d-flex align-items-center mb-5 pr-3") {
                            label("col-3 form-control-label") { +"Событие:" }
                            div("col-9 p-0") {
                                child(dropdownSelect) {
                                    attrs {
                                        dropdownOpenDefault = false
                                        multiSelect = false
                                        showFilter = false
                                        currentValue = mapOf(eventClsName to events[eventClsName].orEmpty())
                                        selectValues = events.map { it.key to it.value }
                                        onSave = {
                                            editedStepType = type.copy(event = when(it.keys.first()) {
                                                "AddSubscriber" -> TriggerEvent.AddSubscriber()
                                                "AbandonedBasket" -> TriggerEvent.AbandonedBasket
                                                "BasketProductPriceDrop" -> TriggerEvent.BasketProductPriceDrop
                                                "ProductsReturnToStore" -> TriggerEvent.ProductsReturnToStore
                                                "Order" -> TriggerEvent.Order
                                                else -> TriggerEvent.AddSubscriber()
                                            })
                                        }
//                                            disabled = !edit
                                    }
                                }
                            }
                        }
                        when (val event = type.event) {
                            is TriggerEvent.AddSubscriber -> {
                                div("form-group row d-flex align-items-center mb-5 pr-3") {
                                    label("col-3 form-control-label") { +"Список подписки:" }
                                    div("col-9 p-0") {
                                        child(dropdownSelect) {
                                            attrs {
                                                dropdownOpenDefault = false
                                                multiSelect = true
                                                showFilter = false
                                                currentValue = event.subscriptionListIds.associateWith { (lists[trigger?.store.orEmpty()] ?: mapOf())[it].orEmpty() }
                                                selectValues = (lists[trigger?.store.orEmpty()] ?: mapOf()).map { it.key to it.value }
                                                onSave = {
                                                    editedStepType = type.copy(event.copy(subscriptionListIds = it.keys.toList()))
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            TriggerEvent.AbandonedBasket -> {}
                            TriggerEvent.BasketProductPriceDrop -> {}
                            TriggerEvent.ProductsReturnToStore -> {}
                            TriggerEvent.Order -> {}
                        }
                    }
                    is TriggerStepType.ActionTriggerStep -> {
                        val actionClsName = type.action::class.simpleName.orEmpty()
                        div("form-group row d-flex align-items-center mb-5 pr-3") {
                            label("col-3 form-control-label") { +"Выполнить действие:" }
                            div("col-9 p-0") {
                                child(dropdownSelect) {
                                    attrs {
                                        dropdownOpenDefault = false
                                        multiSelect = false
                                        showFilter = false
                                        currentValue = mapOf(actionClsName to actions[actionClsName].orEmpty())
                                        selectValues = actions.map { it.key to it.value }
                                        onSave = {
                                            editedStepType = type.copy(action = when(it.keys.first()) {
                                                "Subscribe" -> TriggerAction.Subscribe()
                                                "Unsubscribe" -> TriggerAction.Unsubscribe()
                                                "SendEmail" -> TriggerAction.SendEmail()
                                                "Separate" -> TriggerAction.Separate()
                                                "HttpRequest" -> TriggerAction.HttpRequest()
                                                else -> TriggerAction.Subscribe()
                                            })
                                        }
//                                            disabled = !edit
                                    }
                                }
                            }
                        }
                        when (val action = type.action) {
                            is TriggerAction.Subscribe -> {
                                div("form-group row d-flex align-items-center mb-5 pr-3") {
                                    label("col-3 form-control-label") { +"Магазин:" }
                                    div("col-9 p-0") {
                                        child(dropdownSelect) {
                                            println(mapOf(action.store to stores[action.store].orEmpty()).toString())
                                            attrs {
                                                dropdownOpenDefault = false
                                                multiSelect = false
                                                showFilter = false
                                                currentValue = mapOf(action.store to stores[action.store].orEmpty())
                                                selectValues = stores.map { it.key to it.value }
                                                onSave = {
                                                    editedStepType = type.copy(action.copy(store = it.keys.firstOrNull() ?: stores.keys.first(), lists = listOf()))
                                                }
                                            }
                                        }
                                    }
                                }
                                div("form-group row d-flex align-items-center mb-5 pr-3") {
                                    label("col-3 form-control-label") { +"Списки подписки:" }
                                    div("col-9 p-0") {
                                        child(dropdownSelect) {
                                            attrs {
                                                dropdownOpenDefault = false
                                                multiSelect = true
                                                showFilter = false
                                                currentValue = action.lists.associateWith { (lists[action.store] ?: mapOf())[it].orEmpty() }
                                                selectValues = (lists[action.store] ?: mapOf()).map { it.key to it.value }
                                                onSave = {
                                                    editedStepType = type.copy(action.copy(lists = it.keys.toList()))
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            is TriggerAction.Unsubscribe -> {
                                div("form-group row d-flex align-items-center mb-5 pr-3") {
                                    label("col-3 form-control-label") { +"Магазин:" }
                                    div("col-9 p-0") {
                                        child(dropdownSelect) {
                                            attrs {
                                                dropdownOpenDefault = false
                                                multiSelect = false
                                                showFilter = false
                                                currentValue = mapOf(action.store to stores[action.store].orEmpty())
                                                selectValues = stores.map { it.key to it.value }
                                                onSave = {
                                                    editedStepType = type.copy(action.copy(store = it.keys.firstOrNull() ?: stores.keys.first(), lists = listOf()))
                                                }
                                            }
                                        }
                                    }
                                }
                                div("form-group row d-flex align-items-center mb-5 pr-3") {
                                    label("col-3 form-control-label") { +"Списки подписки:" }
                                    div("col-9 p-0") {
                                        child(dropdownSelect) {
                                            attrs {
                                                dropdownOpenDefault = false
                                                multiSelect = true
                                                showFilter = false
                                                currentValue = action.lists.associateWith { (lists[action.store] ?: mapOf())[it].orEmpty() }
                                                selectValues = (lists[action.store] ?: mapOf()).map { it.key to it.value }
                                                onSave = {
                                                    editedStepType = type.copy(action.copy(lists = it.keys.toList()))
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            is TriggerAction.SendEmail -> {
                                div("form-group row d-flex align-items-center mb-5 pr-3") {
                                    label("col-3 form-control-label") { +"Email:" }
                                    input(InputType.text, classes = "col-9 form-control") {
                                        attrs.value = action.email
                                        attrs.onChangeFunction = {
                                            editedStepType = type.copy(action = action.copy(email = (it.target as? HTMLInputElement)?.value.orEmpty()))
                                        }
                                    }
                                }
                                div("form-group row d-flex align-items-center mb-5 pr-3") {
                                    label("col-3 form-control-label") { +"Тема сообщения:" }
                                    input(InputType.text, classes = "col-9 form-control") {
                                        attrs.value = action.subject
                                        attrs.onChangeFunction = {
                                            editedStepType = type.copy(action = action.copy(subject = (it.target as? HTMLInputElement)?.value.orEmpty()))
                                        }
                                    }
                                }
                                div("form-group row d-flex align-items-center mb-5 pr-3") {
                                    label("col-3 form-control-label") { +"Тело сообщения:" }
                                    input(InputType.text, classes = "col-9 form-control") {
                                        attrs.value = action.body
                                        attrs.onChangeFunction = {
                                            editedStepType = type.copy(action = action.copy(body = (it.target as? HTMLInputElement)?.value.orEmpty()))
                                        }
                                    }
                                }
                            }
                            is TriggerAction.Separate -> {
                                div("form-group row d-flex align-items-center mb-5 pr-3") {
                                    label("col-3 form-control-label") { +"Разделить на две части:" }
                                    input(InputType.number, classes = "col-9 form-control") {
                                        attrs.value = action.percent.toString()
                                        attrs.onChangeFunction = {
                                            editedStepType = type.copy(action = action.copy(percent = (it.target as? HTMLInputElement)?.value?.toIntOrNull() ?: 50))
                                        }
                                    }
                                }
                            }
                            is TriggerAction.HttpRequest -> {
                                div("form-group row d-flex align-items-center mb-5 pr-3") {
                                    label("col-3 form-control-label") { +"URL:" }
                                    input(InputType.text, classes = "col-9 form-control") {
                                        attrs.value = action.url
                                        attrs.onChangeFunction = {
                                            editedStepType = type.copy(action = action.copy(url = (it.target as? HTMLInputElement)?.value.orEmpty()))
                                        }
                                    }
                                }
                                div("form-group row d-flex align-items-center mb-5") {
                                    label("col-3 form-control-label") { +"Тип запроса (GET/POST):" }
                                    div("col-8 styled-checkbox ml-4") {
                                        input(InputType.checkBox) {
                                            attrs.id = "get-request"
                                            attrs.checked = action.getRequest
                                            attrs.onChangeFunction = {
                                                editedStepType = type.copy(action = action.copy(getRequest = !action.getRequest, body = if (action.getRequest) "" else null))
                                            }
                                        }
                                        label("text-primary") {
                                            attrs["htmlFor"] = "get-request"
                                            +if (action.getRequest) "GET" else "POST"
                                        }
                                    }
                                }
                                div("form-group row d-flex align-items-center mb-2 pr-3") {
                                    label("col-3 form-control-label") { +"Заголовки:" }
                                    div("col-9") {
                                        button(type = kotlinx.html.ButtonType.button, classes = "btn btn-outline-primary btn-sm mr-2") {
                                            attrs.onClickFunction = {
                                                editedStepType = type.copy(action = action.copy(headers = action.headers.plus("" to "")))
                                            }
                                            i("la la-plus-circle") {}
                                            +"Добавить"
                                        }
                                        button(type = kotlinx.html.ButtonType.button, classes = "btn btn-outline-danger btn-sm") {
                                            attrs.onClickFunction = {
                                                editedStepType = type.copy(action = action.copy(headers = mapOf()))
                                            }
                                            i("la la-trash") {}
                                            +"Очистить"
                                        }
                                    }
                                }
                                action.headers.entries.forEach { (key, value) ->
                                    child(fc {
                                        var parameterKey by useState(key)
                                        var parameterValue by useState(value)
                                        useEffect(key, value) {
                                            parameterKey = key
                                            parameterValue = value
                                        }
                                        div("form-group row d-flex align-items-center mb-2 pr-3") {
                                            div("col-2") {
                                                button(type = kotlinx.html.ButtonType.button, classes = "btn btn-outline-danger btn-sm") {
                                                    attrs.onClickFunction = {
                                                        val resultHeaders = action.headers.toMutableMap()
                                                        resultHeaders.remove(key)
                                                        editedStepType = type.copy(action = action.copy(headers = resultHeaders))
                                                    }
                                                    i("la la-times-circle") {}
                                                    +"Удалить"
                                                }
                                            }
                                            label("col-1 form-control-label") { +"Ключ:" }
                                            div("col-4") {
                                                input(InputType.text, classes = "form-control") {
                                                    attrs.value = parameterKey
                                                    attrs.onChangeFunction = {
                                                        parameterKey = (it.target as? HTMLInputElement)?.value.orEmpty()
                                                    }
                                                    attrs.onBlurFunction = {
                                                        if (key != parameterKey) {
                                                            val resultHeaders = action.headers.toMutableMap()
                                                            resultHeaders.remove(key)
                                                            resultHeaders[parameterKey] = parameterValue
                                                            editedStepType = type.copy(action = action.copy(headers = resultHeaders))
                                                        }
                                                    }
                                                }
                                            }
                                            label("col-1 form-control-label") { +"Значение:" }
                                            div("col-4") {
                                                input(InputType.text, classes = "form-control") {
                                                    attrs.value = parameterValue
                                                    attrs.onChangeFunction = {
                                                        parameterValue = (it.target as? HTMLInputElement)?.value.orEmpty()
                                                    }
                                                    attrs.onBlurFunction = {
                                                        val resultHeaders = action.headers.toMutableMap()
                                                        resultHeaders[parameterKey] = parameterValue
                                                        editedStepType = type.copy(action = action.copy(headers = resultHeaders))
                                                    }
                                                }
                                            }
                                        }
                                    })
                                }
                                div("em-separator separator-dashed m-2 mb-5") {}

                                div("form-group row d-flex align-items-center mb-2 pr-3") {
                                    label("col-3 form-control-label") { +"Параметры запроса:" }
                                    div("col-9") {
                                        button(type = kotlinx.html.ButtonType.button, classes = "btn btn-outline-primary btn-sm mr-2") {
                                            attrs.onClickFunction = {
                                                editedStepType = type.copy(action = action.copy(params = action.params.plus("" to "")))
                                            }
                                            i("la la-plus-circle") {}
                                            +"Добавить"
                                        }
                                        button(type = kotlinx.html.ButtonType.button, classes = "btn btn-outline-danger btn-sm") {
                                            attrs.onClickFunction = {
                                                editedStepType = type.copy(action = action.copy(params = listOf()))
                                            }
                                            i("la la-trash") {}
                                            +"Очистить"
                                        }
                                    }
                                }
                                action.params.forEachIndexed { parameterIndex, (key, value) ->
                                    child(fc {
                                        var parameterKey by useState(key)
                                        var parameterValue by useState(value)
                                        useEffect(key, value) {
                                            parameterKey = key
                                            parameterValue = value
                                        }
                                        div("form-group row d-flex align-items-center mb-2 pr-3") {
                                            div("col-2") {
                                                button(type = kotlinx.html.ButtonType.button, classes = "btn btn-outline-danger btn-sm") {
                                                    attrs.onClickFunction = {
                                                        val resultParams = action.params.toMutableList()
                                                        resultParams.removeAt(parameterIndex)
                                                        editedStepType = type.copy(action = action.copy(params = resultParams))
                                                    }
                                                    i("la la-times-circle") {}
                                                    +"Удалить"
                                                }
                                            }
                                            label("col-1 form-control-label") { +"Ключ:" }
                                            div("col-4") {
                                                input(InputType.text, classes = "form-control") {
                                                    attrs.value = parameterKey
                                                    attrs.onChangeFunction = {
                                                        parameterKey = (it.target as? HTMLInputElement)?.value.orEmpty()
                                                    }
                                                    attrs.onBlurFunction = {
                                                        val resultParams = action.params.toMutableList()
                                                        resultParams[parameterIndex] = parameterKey to parameterValue
                                                        editedStepType = type.copy(action = action.copy(params = resultParams))
                                                    }
                                                }
                                            }
                                            label("col-1 form-control-label") { +"Значение:" }
                                            div("col-4") {
                                                input(InputType.text, classes = "form-control") {
                                                    attrs.value = parameterValue
                                                    attrs.onChangeFunction = {
                                                        parameterValue = (it.target as? HTMLInputElement)?.value.orEmpty()
                                                    }
                                                    attrs.onBlurFunction = {
                                                        val resultParams = action.params.toMutableList()
                                                        resultParams[parameterIndex] = parameterKey to parameterValue
                                                        editedStepType = type.copy(action = action.copy(params = resultParams))
                                                    }
                                                }
                                            }
                                        }
                                    })
                                }
                                div("em-separator separator-dashed m-2 mb-5") {}

                                if (!action.getRequest) {
                                    div("form-group row d-flex align-items-center mb-5 pr-3") {
                                        label("col-3 form-control-label") { +"Тело запроса:" }
                                        div("col-9") {
                                            input(InputType.text, classes = "form-control") {
                                                attrs.value = action.body.orEmpty()
                                                attrs.onChangeFunction = {
                                                    editedStepType = type.copy(action = action.copy(body = (it.target as? HTMLInputElement)?.value.orEmpty()))
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    else -> {}
                }
            }
        }
        ModalFooter {
            Button {
                attrs.variant = "secondary"
                attrs.onClick = {
                    (editedStepType as? TriggerStepType.EmailTriggerStep)?.attachments?.let { attachments ->
                        val currentAttachments = (editStep?.type as? TriggerStepType.EmailTriggerStep)?.attachments?.map { it.fileName } ?: listOf()

                        val newAttachments = attachments.filterNot { currentAttachments.contains(it.fileName) }
                        newAttachments.forEach { file ->
                            Http.delete("/files/${file.fileName}") {}
                        }
                    }
                    editStep = null
                }
                +"Отмена"
            }
            Button {
                attrs.variant = "gradient-01"
                attrs.onClick = {

//                    steps = steps.minus(deleteId).mapValues { (_, value) ->
//                        if (value.connections.flatten().contains(deleteId)) {
//                            val connections = value.connections.map { it.minus(deleteId) }
//                            value.copy(connections = connections)
//                        } else {
//                            value
//                        }
//                    }
                    editStep?.let {

                        val resultDelay = if (isDelay) delayText.toLongOrNull() ?: 0L else -1L
                        val resultRandomDelay = if (isDelay) randomText.toLongOrNull() ?: 0L else 0L
                        val type = when(val t = editedStepType) {
                            null -> it.type
                            is TriggerStepType.EmailTriggerStep -> t.copy(template = t.template)
                            else -> t
                        }
                        steps = steps.plus(it.id to it.copy(delay = resultDelay, randomDelay = resultRandomDelay, type = type))
                    }
                    editStep = null
                }
                +"Сохранить"
            }
        }
    }

    useEffect(id) {
        id?.let {
            Http.get("/triggers/$id") { response ->
                response.checkResponseError()?.let { error ->
                    showNotification(error, NotyType.Error)
                    navigate("/triggers")
                    return@get
                }
                trigger = response.body()
            }
        }
    }
    useEffect(trigger) {
        steps = trigger?.steps?.associate { it.id to it } ?: mapOf()
        expandStates = trigger?.steps?.associate { it.id to true } ?: mapOf()
        stats = trigger?.stats?.associate { it.step to it } ?: mapOf()
//        templates = trigger?.steps?.filter { it.type is TriggerStepType.EmailTriggerStep }?.associate {
//            it.id to (it.type as TriggerStepType.EmailTriggerStep).template
//        } ?: mapOf()

        trigger?.store?.let { storeId ->
            Http.get("/senders", mapOf("store" to storeId)) { response ->
                response.checkResponseError()?.let { error ->
                    showNotification(error, NotyType.Error)
                    return@get
                }
                val result = response.body<List<Sender>>()
                senders = result.associate { it.id to it.name }
            }
            Http.get("/stores") { response ->
                response.checkResponseError()?.let {
                    showNotification(it, NotyType.Error)
                    return@get
                }
                stores = response.body<List<Store>>().associate { it.id to it.name }
            }
            Http.get("/subscribers/lists") { response ->
                response.checkResponseError()?.let {
                    showNotification(it, NotyType.Error)
                    return@get
                }
                lists = response.body<List<SubscriptionList>>().groupBy { it.store }.mapValues { (_, items) -> items.associate { it.id to it.name } }
            }
            Http.get(
                "/campaigns",
                mapOf(),
                builder = {
                    url {
                        parameters.append("rows", "-1")
                        parameters.append("store", storeId)
                        parameters.appendAll("status", listOf(EmailCampaignStatus.Complete.name))
                    }
                }
            ) { response ->
                response.checkResponseError()?.let {
                    showNotification(it, NotyType.Error)
                    return@get
                }
                val result = response.body<List<EmailCampaignTitle>>()
                campaigns = result.associate { it.id to it.name }
            }
            Http.get("/segments", mapOf("store" to storeId)) { response ->
                response.checkResponseError()?.let {
                    showNotification(it, NotyType.Error)
                    return@get
                }
                dynamicSegments = response.body<List<NamedItem>>().associate { it.id to it.name }
            }
            Http.get("/segments/static", mapOf("store" to storeId)) { response ->
                response.checkResponseError()?.let {
                    showNotification(it, NotyType.Error)
                    return@get
                }
                staticSegments = response.body<List<NamedItem>>().associate { it.id to it.name }
            }
        }
    }
    useEffect(steps) {
        stepPositions = when {
            stepPositions.isEmpty() && steps.isNotEmpty() -> {
                newStepId = steps.maxOf { it.value.id } + 1
                steps.mapValues { (_, step) -> step.position }
            }
            steps.size < stepPositions.size -> { // removed one step
                stepPositions.minus(stepPositions.keys.filter { !steps.keys.contains(it) })
            }
            stepPositions.keys.intersect(steps.keys).size != steps.keys.size -> { // add one step
                newStepId += 1
                stepPositions.plus(steps.filterKeys { !stepPositions.keys.contains(it) }.mapValues { (_, step) -> step.position })
            }
            else -> { // another changes (connections)
                stepPositions
            }
        }
//        stepPositions = stepPositions
//            .minus(stepPositions.keys.filter { !steps.keys.contains(it) })
//            .plus(steps.filterKeys { !stepPositions.keys.contains(it) }.mapValues { (_, step) -> step.position })
//        newStepId = when {
//            newStepId == 0 && steps.isNotEmpty() -> steps.keys.maxOf { key -> key } + 1
//            newStepId > 0 -> newStepId + 1
//            else -> 0
//        }
    }

    useEffect(steps, stepPositions, width, height, expandStates) {
        stepConnectionLines = steps.flatMap { (stepId, step) ->
            val connectorsSize = step.connections.size
            val connectorsPlateWidth = 250 / connectorsSize
            val startPosition = stepPositions[stepId]
            step.connections.flatMapIndexed { connectorIndex, connections ->
                val startPointX = (startPosition?.x ?: 0.0f) * width + (connectorIndex + 0.5f) * connectorsPlateWidth
                val startPointY = (startPosition?.y ?: 0.0f) * height + (if (expandStates[step.id] != false) 200 else 48)

                connections.mapNotNull { id ->
                    steps[id]?.let { endStep ->
                        val endPosition = stepPositions[id]
                        val endPointX = (endPosition?.x ?: 0.0f) * width + 125
                        val endPointY = (endPosition?.y ?: 0.0f) * height

//                        "M$startPointX $startPointY Q $startPointX ${startPointY + 60}, ${startPointX+(endPointX-startPointX)/2.0f} ${startPointY+(endPointY-startPointY)/2.0f} T $endPointX $endPointY"

                        jso<dynamic> {
                            d = "M$startPointX $startPointY Q $startPointX ${startPointY + 60}, ${startPointX+(endPointX-startPointX)/2.0f} ${startPointY+(endPointY-startPointY)/2.0f} T $endPointX $endPointY"
                            fill = "none"
                            stroke = "#A2CDCD"
                            strokeWidth = 4
                            strokeLinecap = "round"
                        }
                    }
                }
            }
        }
    }

    val divRef = useRef<HTMLDivElement>()
    useEffect(divRef.current) {
        divRef.current?.let {
            width = it.clientWidth.toFloat()
            height = it.clientHeight.toFloat()
        }
    }

    child(oldcomponents.header) {
        attrs {
            isExtended = isSidebarOpened
            onExtendButtonClick = {
                isSidebarOpened = !isSidebarOpened
            }
        }
    }

    div("page-content d-flex align-items-stretch") {
        div("default-sidebar") {
            styledNav {
                css.classes.addAll(
                    listOf(
                        "side-navbar",
                        "box-scroll",
                        "sidebar-scroll"
                    )
                )
                if (!isSidebarOpened) {
                    css.classes += "shrinked"
                }

                span("heading") {
                    +"Управление триггером"
                }
                ul("list-unstyled mb-3") {

                    if (trigger?.status == TriggerStatus.Started) {
                        listOf(
                            Triple("stop", "la la-hand-stop-o", "Остановить триггер"),
                            Triple("stats", "la la-line-chart", "Статистика"),
                        )
                    } else {
                        listOf(
                            Triple("save", "la la-save", "Сохранить"),
                            Triple("start", "la la-play-circle-o", "Запустить триггер"),
                        )
                    }.plus(Triple("back", "la la-power-off", "Вернуться к списку"))
                        .forEach { (action, icon, name) ->
                            li {
                                styledA {
                                    attrs.onClickFunction = { e ->
                                        e.preventDefault()
                                        e.stopPropagation()
                                        when (action) {
                                            "save" -> {
                                                trigger?.copy(
                                                    steps = steps.values.map { it.copy(position = stepPositions[it.id]!!) }
                                                )?.let {
                                                    Http.post("/triggers/${it.id}", it) { response ->
                                                        response.checkResponseError()?.let { error ->
                                                            showNotification(error, NotyType.Error)
                                                            return@post
                                                        }
                                                        Http.get("/triggers/$id") { response1 ->
                                                            response1.checkResponseError()?.let { error ->
                                                                showNotification(error, NotyType.Error)
                                                                navigate("/triggers")
                                                                return@get
                                                            }
                                                            trigger = response1.body()
                                                        }
                                                    }
                                                }
                                            }
                                            "start", "stop" -> {
                                                Http.get("/triggers/${trigger?.id}/$action") { response ->
                                                    response.checkResponseError()?.let { error ->
                                                        showNotification(error, NotyType.Error)
                                                        return@get
                                                    }
                                                    navigate("/triggers")
                                                }
                                            }
                                            "stats" -> { showStats = !showStats }
                                            "back" -> { navigate("/triggers") }
                                            else -> {}
                                        }
                                    }
                                    css {
                                        cursor = Cursor.pointer
                                    }
                                    i(icon) {}
                                    span { +name }
                                }
                            }
                        }
                }

                if (trigger?.status != TriggerStatus.Started) {
                    span("heading") {
                        +"Создать новый шаг"
                    }
                    ul("list-unstyled mb-3") {
                        listOf(
                            Triple("StartTriggerStep", "la la-play-circle", "Старт серии"),
                            Triple("TargetTriggerStep", "la la-check-circle-o", "Цель"),
                            Triple("FilterTriggerStep", "la la-filter", "Фильтр"),
                            Triple("EmailTriggerStep", "la la-envelope-o", "E-mail"),
                            Triple("ConditionTriggerStep", "la la-balance-scale", "Условие"),
                            Triple("ActionTriggerStep", "la la-cogs", "Действие"),
                        ).forEach { (clsName, icon, name) ->
                            li {
                                styledA {
                                    attrs.onClickFunction = { e ->
                                        e.preventDefault()
                                        e.stopPropagation()
                                        var outputConnectorsCount = 2
                                        when (clsName) {
                                            "StartTriggerStep" -> {
                                                outputConnectorsCount = 1
                                                TriggerStepType.StartTriggerStep()
                                            }
                                            "TargetTriggerStep" -> {
                                                outputConnectorsCount = 0
                                                TriggerStepType.TargetTriggerStep("Новая цель")
                                            }
                                            "FilterTriggerStep" -> TriggerStepType.FilterTriggerStep()
                                            "EmailTriggerStep" -> TriggerStepType.EmailTriggerStep()
                                            "ConditionTriggerStep" -> TriggerStepType.ConditionTriggerStep()
                                            "ActionTriggerStep" -> TriggerStepType.ActionTriggerStep()
                                            else -> null
                                        }?.let {
                                            val newStep = TriggerStep(newStepId, TriggerStepPosition(), List(outputConnectorsCount) { setOf() }, type = it)
                                            steps = steps.plus(newStepId to newStep)
                                            editStep = newStep
                                        }
                                    }
                                    css {
                                        cursor = Cursor.pointer
                                    }
                                    i(icon) {}
                                    span { +name }
                                }
                            }
                        }
                    }
                }
            }
        }
        child(pageContent) {
            attrs.active = !isSidebarOpened
            if (width > 0 && height > 0) {
                styledSvg {
                    attrs.onMouseMoveFunction = {
                        val mouseEvent = it.asDynamic().nativeEvent as MouseEvent
                        svgMousePosition = mouseEvent.offsetX.toFloat() to mouseEvent.offsetY.toFloat()
                    }
                    attrs.onClickFunction = {
                        selectedConnector = null
                        selectedConnectorPosition = null
                    }
                    css {
                        this.overflow = Overflow.hidden
                        this.width = (width.toInt() - 30).px
                        this.height = (height.toInt() - 30).px
                        this.position = kotlinx.css.Position.absolute
                        this.left = 30.px
                        this.top = 30.px
                    }
                    stepConnectionLines.forEach {
                        child(createElement( path , it))

                    }
                    selectedConnectorPosition?.let { (x, y) ->
//                        println("$x $y  ${svgMousePosition.first} ${svgMousePosition.second}")
                        if (hoverStep != selectedConnector?.first) {
                            val hoverStepPosition = steps[hoverStep]?.position
                            child(createElement(line, jso<dynamic> {
                                x1 = x
                                y1 = y
                                x2 = hoverStepPosition?.let { it.x * width + 125 } ?: svgMousePosition.first
                                y2 = hoverStepPosition?.let { it.y * height } ?: svgMousePosition.second
                                fill = "none"
                                stroke = "#A2CDCD"
                                strokeWidth = 4
                                strokeLinecap = "round"
                            }))
                        }
                    }
                }
            }
            styledDiv {
                ref = divRef
                css {
                    this.overflow = Overflow.visible
                    minHeight = 1200.px
                    this.height = 100.vh
                }

//                styledDiv {
//                    css {
////                        position = Position.relative
//                        width = 100.pct
//                        height = 100.pct
//                    }
//                }

                if (width > 0 && height > 0) {
                    steps.forEach { (id, step) ->
                        val position = stepPositions[id] ?: step.position
//                        println("$id: ${step.type::class.simpleName} ${position}")
                        triggerBlockComponent {
                            attrs.width = width
                            attrs.height = height
                            attrs.step = step
                            attrs.stats = stats[id]
                            attrs.expand = expandStates[id] ?: true
                            attrs.showStats = showStats
                            attrs.onExpandChange = {
                                expandStates = expandStates.plus(id to it)
                            }
                            attrs.position = position
                            attrs.onStartDrag = {
                                dragId = id
                            }
                            attrs.zIndex = if (dragId == id) 1000 else id
                            attrs.onEdit = { editStep = step.copy() }
                            attrs.onDelete = { deleteId = id }
                            attrs.isDragging = dragId != -1
                            attrs.move = { newX, newY ->
                                var value = newX / width
                                val resultX = when {
                                    value < 0 -> 0.0f
                                    value > 0.98f -> 0.98f
                                    else -> value
                                }
                                value = newY / height
                                val resultY = when {
                                    value < 0 -> 0.0f
                                    value > 0.98f -> 0.98f
                                    else -> value
                                }
                                dragId = -1
                                stepPositions = stepPositions.plus(id to TriggerStepPosition(resultX, resultY))
                            }

                            attrs.onHover = { isHover ->
                                hoverStep = if (isHover) id else -1
                            }
                            attrs.connectorSelected = { connectorId, x, y ->
                                when {
                                    connectorId >= 0 -> {
                                        selectedConnector = id to connectorId
                                        selectedConnectorPosition = x + (stepPositions[id]?.x ?: 0.0f) * width to y + (stepPositions[id]?.y ?: 0.0f) * height
                                    }
                                    selectedConnector != null -> {
                                        steps[selectedConnector!!.first]?.let { startStep ->
                                            if (!startStep.connections.flatten().contains(id)) {
                                                val connections = startStep.connections.toMutableList()
                                                connections[selectedConnector!!.second] = connections[selectedConnector!!.second].plus(step.id)
                                                steps = steps.plus(startStep.id to startStep.copy(connections = connections))
                                            }

                                            selectedConnector = null
                                            selectedConnectorPosition = null
                                        }
                                    }
                                    else -> {

                                    }
                                }
                            }
                        }
                    }
                }
//                Draggable {
//                    println("$testX $testY")
//                    attrs.handle = "#test0"
//                    attrs.position = jso {
//                        this.x = testX
//                        this.y = testY
//                    }
//                    attrs.onDrag = { _, d ->
//                        testX += d.deltaX.toInt()
//                        testY += d.deltaY.toInt()
//                    }
//                    div("widget has-shadow") {
//                        attrs.id = "test0"
//                        attrs.jsStyle {
//                            width = "100px"
//                            height = "100px"
//                            background = "white"
//                            position = "absolute"
//                        }
//                    }
//                }
            }
        }
    }
}